/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Press_American_BankerInputs */

const en_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const de_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const pt_br2_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const tr_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const zh_cn2_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const zh_hk2_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const ko_kr2_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const ru_ru2_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

const es_419_onboarding_v1_press_american_banker = /** @type {(inputs: Onboarding_V1_Press_American_BankerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`American Banker`)
};

/**
* | output |
* | --- |
* | "American Banker" |
*
* @param {Onboarding_V1_Press_American_BankerInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_press_american_banker = /** @type {((inputs?: Onboarding_V1_Press_American_BankerInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Press_American_BankerInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_press_american_banker(inputs)
	if (locale === "de") return de_onboarding_v1_press_american_banker(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_press_american_banker(inputs)
	if (locale === "tr") return tr_onboarding_v1_press_american_banker(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_press_american_banker(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_press_american_banker(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_press_american_banker(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_press_american_banker(inputs)
	return es_419_onboarding_v1_press_american_banker(inputs)
});